/* eslint-disable */
<template>
  <div id="mainGraphPane" ref="mainGraphPane">
    <SearchNode />
    <div ref="mountNode">
      <div v-if="propShow" class="propsShowcase d-flex">
        <p class="px-2" v-for="(value, prop) in propDetail" :key="prop"><span class="propName">{{prop}}</span>: {{value.value}},</p>
      </div>
    </div>
    <div v-if="nodeUpdating">
      <NodeInput
        :nodeLabel="updateNode.nodeLabel"
        :nodeId="updateNode.id"
        @nodeLabelUpdate="updateNodeLabel"
        :position="updateNode.position"
      />
    </div>
  </div>
</template>

<script>
import G6 from '@antv/g6';
import { GraphLayoutPredict } from '@antv/vis-predict-engine';
import ExploreToDendro from '@/plugins/exploreToDendro';
import axios from 'axios';
import { tooltip, minimap, toolbar } from '@/utils/graphPlugins';
import graphReactor from '@/graphReactor';
import exploreOps from '@/utils/exploreOps';
import graphConfig from '../plugins/graphConfig';
import nodeHsl from '../plugins/nodeHsl';
import SearchNode from './SearchNode.vue';
import NodeInput from './NodeInput.vue';

export default {
  components: {
    SearchNode,
    NodeInput,
  },
  data() {
    return {
      content: '',
      propShow: false,
      propDetail: {},
      toggleGraph: true,
      searchWord: '',
      updateNode: {
        nodeLabel: '',
        position: {},
        id: '',
      },
      nodeUpdating: false,
      selectedNodesG6: [],
    };
  },

  computed: {
    getEdgeStrength() {
      return this.$store.state.edge_strength;
    },
    explore_data() {
      return this.$store.state.gmodule.g6_explore_data;
    },
    edit_mode() {
      return this.$store.state.edit_mode;
    },
  },

  watch: {
    getEdgeStrength(val) {
      this.config.layout.edgeStrength = Number(val);
      // Comment
      graphReactor.exploreInstance.updateLayout({
        edgeStrength: Number(val),
      });
      // console.log('edgeStrength: ', val);
      // this.config.layout.edgeStrength = Number(val);
      // const controller = graphReactor.exploreInstance.get('layout');
      // controller.edgeStrength = Number(val);
      // console.log('controller: ', controller);
      // graphReactor.exploreInstance.set('layout', controller);
      // console.log('pkkarn: ', graphReactor.exploreInstance.get('layout'));
      // graphReactor.exploreInstance.setAutoPaint(true);
    },
    async explore_data(val) {
      // const { predictLayout } = await GraphLayoutPredict.predict(val);
      // const layout = {
      //   type: predictLayout,
      //   nodeSize: 50,
      //   preventOverlap: true,
      // };
      graphReactor.exploreInstance.changeData(val);
      graphReactor.exploreInstance.updateLayout();
    },
    edit_mode(val) {
      console.log('edit_mode: ', val);
      if (val === 'default') {
        graphReactor.exploreInstance.setMode('default');
      } else {
        graphReactor.exploreInstance.setMode('defaultMain');
      }
    },
  },

  async mounted() {
    this.addedNodeCount = 0;
    await this.wikiGraphBuild();
    new ResizeObserver(this.resizeLayout).observe(this.$refs.mainGraphPane);
  },
  async created() {
    // Add Note to Graph
    this.$root.$on('note-add-to-graph', this.addNoteToGraph);

    this.$root.$on('delete-selected-nodes', this.deleteSelectedNodes);

    // Delete Note from Graph

    // Delete Note from Graph
    this.$root.$on('combo-create-select', this.comboCreateSelect);

    // Delete Note from Graph
    this.$root.$on('node-create-select', this.nodeCreateSelect);
  },
  beforeDestroy() {
    this.$root.$off('note-add-to-graph');
    this.$root.$off('combo-create-select');
    this.$root.$off('node-create-select');
    this.$root.$off('delete-selected-nodes');
  },
  methods: {
    nodeCreateSelect(payload) {
      exploreOps.nodeCreateSelect(payload, this.selectedNodesG6);
    },

    resizeLayout() {
      graphReactor.exploreInstance.changeSize(this.$refs.mainGraphPane.scrollWidth, this.$refs.mainGraphPane.scrollHeight);
    },
    comboCreateSelect(label) {
      exploreOps.comboCreateSelect(label, this.selectedNodesG6);
    },

    uniqueIdGenerate() {
      // Generate random id for node
      return Math.random().toString(36).substr(2, 9);
    },

    // Delete Selected Nodes
    deleteSelectedNodes() {
      exploreOps.deleteSelectedNodes(this.selectedNodesG6);
    },

    nodeSelectChange(e) {
      this.$store.dispatch('toggleGroupMode', e.select);
      console.log('nodeSelectChange: ', e);
      this.selectedNodesG6 = e.selectedItems.nodes;
    },

    addNoteToGraph(item) {
      exploreOps.addNoteToGraph(item);
    },

    clearStates() {
      graphReactor.exploreInstance.getNodes().forEach((node) => {
        graphReactor.exploreInstance.clearItemStates(node);
        this.setOpacityLabel(node, 1);
      });
      graphReactor.exploreInstance.getEdges().forEach((edge) => {
        graphReactor.exploreInstance.clearItemStates(edge);
        this.setOpacityLabel(edge, 1);
      });

      graphReactor.exploreInstance.getCombos().forEach((combo) => {
        graphReactor.exploreInstance.clearItemStates(combo);
      });
    },

    videoEmbedURLFromURL(url) {
      if (url) {
        const regex = /^https?:\/\/(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\S+)?$/;
        const match = url.match(regex);
        if (match && match[1].length === 11) {
          return `https://www.youtube.com/embed/${match[1]}?rel=0`;
        }
      }
      return '';
      // ^.*(youtu.be\/|v\/|embed\/|watch\?|youtube.com\/user\/[^#]*#([^\/]*?\/)*)\??v?=?([^#\&\?]*).*
    },

    updateNodeLabel(payload) {
      const updatedNode = graphReactor.exploreInstance.findById(payload.id);
      updatedNode.update({
        label: payload.labelName,
      });
      this.nodeUpdating = false;
    },

    async changeGraph(searchWord) {
      await this.$store
        .dispatch('gmodule/exploreGraphFetch', searchWord)
        .then(() => {
          // console.log(graphReactor.exploreInstance);
          graphReactor.exploreInstance.changeData(
            this.$store.state.gmodule.g6_explore_data,
          );
        });
    },

    async wikiGraphBuild() {
      this.gdata = this.$store.state.gmodule.g6_explore_data;
      const { predictLayout } = await GraphLayoutPredict.predict(
        this.$store.state.gmodule.g6_explore_data,
      );
      this.config = graphConfig;
      this.config.container = this.$refs.mountNode;
      this.config.plugins = [minimap, tooltip, toolbar];
      this.config.container = this.$refs.mountNode;
      this.config.width = this.$refs.mainGraphPane.scrollWidth;
      this.config.height = this.$refs.mainGraphPane.scrollHeight;
      this.config.layout = {
        type: predictLayout,
        nodeSize: 50,
        preventOverlap: true,
      };

      graphReactor.exploreInstance = new G6.Graph(this.config);

      graphReactor.exploreInstance.on('canvas:click', this.canvasClick);

      graphReactor.exploreInstance.on('combo:click', this.comboClick);
      // Click Event
      graphReactor.exploreInstance.on('node:click', this.nodeClick);

      graphReactor.exploreInstance.on('node:dblclick', this.nodeDblClick);

      graphReactor.exploreInstance.on(
        'nodeselectchange',
        this.nodeSelectChange,
      );

      graphReactor.exploreInstance.on('node:mouseenter', (e) => {
        this.propDetail = e.item.getModel().props;
        this.propShow = true;
      });

      graphReactor.exploreInstance.on('node:mouseleave', () => {
        this.propShow = false;
        this.propDetail = {};
      });

      graphReactor.exploreInstance.on('mousemove', this.exploreMouseMove);

      graphReactor.exploreInstance.on('edge:click', this.edgeClick);

      graphReactor.exploreInstance.data(
        this.$store.state.gmodule.g6_explore_data,
      );
      graphReactor.exploreInstance.render();

      graphReactor.exploreInstance.updateLayout({
        type: 'gForce',
      });

      // document.querySelector('.g6').onresize = () => {
      //   console.log('resize');
      //   const myCanvas = this.$refs.mountNode;
      //   // console.log(myCanvas.clientWidth);
      //   // console.log(myCanvas.clientHeight);
      //   // if (!graphReactor.exploreInstance || graphReactor.exploreInstance.get('destroyed')) return;
      //   // if (!container || !container.scrollWidth || !container.scrollHeight) return;
      //   graphReactor.exploreInstance.changeSize(myCanvas.clientWidth, 708);
      //   // graphReactor.exploreInstance.fitCenter();
      // };
    },

    // Wiki Graph Build Operations:

    // Canvas Click Operation
    canvasClick(ev) {
      console.log('canvasClick: ', ev);
      this.nodeUpdating = false;
      if (this.$store.state.edit_mode === 'clear_graph') {
        this.$store.commit('gmodule/EMPTY_GRAPH');
      } else if (this.$store.state.edit_mode === 'add_nodes') {
        exploreOps.addNodeGraph({
          pos: {
            x: ev.canvasX,
            y: ev.canvasY,
          },
        });
      } else {
        this.clearStates();
      }
    },

    // Combo Click Operation
    comboClick(e) {
      if (this.$store.state.edit_mode === 'combo_explore') {
        this.$store.dispatch(
          'gmodule/exploreThoughtMap',
          e.item.getModel().tjData,
        );
      } else if (this.$store.state.edit_mode === 'combo_expand_collapse') {
        // expand and collapse combo
        graphReactor.exploreInstance.collapseExpandCombo(e.item);
      }
    },

    // Node Click Operation
    async nodeClick(e) {
      const nodeItem = e.item;
      const nodeModel = nodeItem.getModel();

      console.log('node:click', nodeModel);
      // graphReactor.exploreInstance.focusItem(nodeItem);
      ExploreToDendro(nodeModel.id);
      // // State manipulation of nodes
      // graphReactor.exploreInstance.findAllByState('node', 'focusEd').forEach((node) => {
      //   graphReactor.exploreInstance.clearItemStates(node, 'focusEd');
      // });
      // graphReactor.exploreInstance.setItemState(nodeItem, 'focusEd', true);
      console.log('Node Click', nodeItem);
      if (this.$store.state.edit_mode === 'explore') {
        // graphReactor.exploreInstance.collapseCombo('combo1');
        console.log('exploreMyWorld', e.item);
        let nodeId = null;
        // eslint-disable-next-line
        const { id, tjType, label } = e.item._cfg.model;
        if (tjType === 'wikiLinks') {
          nodeId = id;
          // this.$store.dispatch('youtubeSearchByKeyword', id);
        } else {
          nodeId = label;
        }
        console.log('nodeId', nodeId);
        // console.log('Node click', nodeId);
        const clickNodes = graphReactor.exploreInstance.findAllByState(
          'node',
          'click',
        );
        clickNodes.forEach((cn) => {
          // console.log(cn);
          graphReactor.exploreInstance.setItemState(cn, 'click', false);
        });

        graphReactor.exploreInstance.setItemState(nodeItem, 'click', true);

        // eslint-disable-next-line
        // const labelNode = nodeItem._cfg.id;
        const wordObj = {
          word: nodeId,
          label: nodeId,
          type: 'string',
          lang: 'en',
        };

        // this.$store.commit('SET_CURRENT_ENTITY', wordObj);
        await this.$store.dispatch('setCurrentThought', wordObj);
        // eslint-disable-next-line
        graphReactor.exploreInstance.data(
          this.$store.state.gmodule.g6_explore_data,
        );
        graphReactor.exploreInstance.render();
        const updatedNode = graphReactor.exploreInstance.findById(nodeId);
        // console.log(updatedNode);
        // updatedNode.update({
        //   // label: `${this.$store.state.gmodule.mainNodesOfExplore.length}`,
        //   size: 40,
        //   style: {
        //     fill: '#fff',
        //     stroke: '#333',
        //   },
        // });
        // Dispatching function manually
        // eslint-disable-next-line

        graphReactor.exploreInstance.focusItem(updatedNode, true, {
          easing: 'easeCubic',
          duration: 400,
        });
        axios.post(`${process.env.VUE_APP_ZELDA_URI}event`, {
          actor: this.$store.state.userInfo,
          verb: 'EXPLORED',
          value: 'eventData',
          dataSource: 'TJ-CLIENT',
        });
        // console.log('GDATA', graphReactor.exploreInstance.save());
        // axios.post(`${process.env.VUE_APP_ZELDA_URI}event`, {
        //   actor: this.$store.state.userInfo,
        //   verb: 'GRAPHED',
        //   value: {
        //     data: graphReactor.exploreInstance.save(),
        //   },
        //   dataSource: 'TJ-CLIENT',
        // });
      } else if (this.$store.state.edit_mode === 'remove') {
        graphReactor.exploreInstance.removeItem(nodeItem);
      } else if (this.$store.state.edit_mode === 'hide') {
        nodeItem.hide();
      } else if (this.$store.state.edit_mode === 'lock') {
        nodeItem.lock();
      } else if (this.$store.state.edit_mode === 'shortest_path') {
        // graphReactor.exploreInstance.setMode('shortest_path');
        setTimeout(() => {
          const selectedNodes = graphReactor.exploreInstance.findAllByState(
            'node',
            'selected',
          );

          // console.log('game of theoneb', selectedNodes.length);
          if (selectedNodes.length === 2) {
            // console.log('Please select TWO nodes!\n\r请选择有且两个节点！');
            const { findShortestPath } = G6.Algorithm;
            // eslint-disable-next-line
            const { path, allPath } = findShortestPath(
              this.$store.state.gmodule.g6_explore_data,
              selectedNodes[0].getID(),
              selectedNodes[1].getID(),
            );
            const pathNodeMap = {};
            path.forEach((id) => {
              const pathNode = graphReactor.exploreInstance.findById(id);
              pathNode.toFront();
              graphReactor.exploreInstance.setItemState(
                pathNode,
                'highlight',
                true,
              );
              pathNodeMap[id] = true;
            });
            graphReactor.exploreInstance.getEdges().forEach((edge) => {
              const edgeModel = edge.getModel();
              const { source } = edgeModel;
              const { target } = edgeModel;
              const sourceInPathIdx = path.indexOf(source);
              const targetInPathIdx = path.indexOf(target);
              if (sourceInPathIdx === -1 || targetInPathIdx === -1) return;
              if (Math.abs(sourceInPathIdx - targetInPathIdx) === 1) {
                graphReactor.exploreInstance.setItemState(
                  edge,
                  'highlight',
                  true,
                );
              } else {
                graphReactor.exploreInstance.setItemState(
                  edge,
                  'inactive',
                  true,
                );
              }
            });
            graphReactor.exploreInstance.getNodes().forEach((node) => {
              if (!pathNodeMap[node.getID()]) {
                graphReactor.exploreInstance.setItemState(
                  node,
                  'inactive',
                  true,
                );
              }
            });
          }
        }, 1000);
      } else if (this.$store.state.edit_mode === 'default') {
        // remove this to work with click select
        // eslint-disable-next-line
        this.$highway.excludeDispatcher(nodeItem._cfg.id, [
          'gmodule/exploreGraphFetch',
        ]);
      } else if (this.$store.state.edit_mode === 'hide_related_nodes') {
        // eslint-disable-next-line
        console.log("hide related nodes", nodeItem);
        nodeItem.getNeighbors('target').forEach((neighbor) => {
          // graphReactor.exploreInstance.setItemState(neighbor, 'selected', false);
          console.log(neighbor);
          neighbor.hide();
        });
        nodeItem.getOutEdges().forEach((edge) => {
          // graphReactor.exploreInstance.setItemState(edge, 'selected', false);
          edge.hide();
        });
      } else if (this.$store.state.edit_mode === 'show_related_nodes') {
        // eslint-disable-next-line
        nodeItem.getNeighbors(nodeItem._cfg.id).forEach((neighbor) => {
          neighbor.show();
        });
        nodeItem.getOutEdges().forEach((neighbor) => {
          neighbor.show();
        });
      } else if (this.$store.state.edit_mode === 'node_operation') {
        // eslint-disable-next-line
        const model = nodeItem._cfg.model;
        this.$highway.excludeDispatcher(model.label, [
          'gmodule/exploreGraphFetch',
        ]);

        this.content = nodeItem.getModel();
        this.formDataObj = model;
        const payload = {
          content: this.content,
          formDataObj: this.formDataObj,
        };

        // search engine keyword fetch trigger
        this.$store.dispatch('searchEngine/setKeyword', payload.content.label);

        setTimeout(() => {
          this.$store.dispatch('updateDetailPayload', payload);
          console.log('EXPLORERS PAYLOADSSS...', payload);
          if (payload.content.tjType === 'wikiLinks' || payload.content.tjType === 'custom-node') {
            this.clearStates();
            const nodeItemNodeOperation = graphReactor.exploreInstance.findById(
              payload.content.id,
            );
            graphReactor.exploreInstance.setItemState(
              nodeItemNodeOperation,
              'focusEd',
              true,
            );
            console.log('EDVANTA INDEX', payload.content.label);
            this.$store.dispatch(
              'youtubeSearchByKeyword',
              payload.content.label,
            );
            console.log('EDVANTA', payload.content.label);
          }
        }, 100);
      } else if (this.$store.state.edit_mode === 'add_relationships') {
        const node = e.item;
        const point = {
          x: e.x,
          y: e.y,
        };
        const model = node.getModel();
        if (this.addingEdge && this.edge) {
          graphReactor.exploreInstance.updateItem(this.edge, {
            target: model.id,
            label: this.$store.state.newEdgeLabel,
          });
          this.edge = null;
          this.addingEdge = false;
        } else {
          this.edge = graphReactor.exploreInstance.addItem('edge', {
            source: model.id,
            target: point,
            label: this.$store.state.newEdgeLabel,
          });
          this.addingEdge = true;
        }
      } else if (this.$store.state.edit_mode === 'hsl') {
        nodeHsl(nodeModel);
      }
    },

    setOpacityLabel(item, val) {
      graphReactor.exploreInstance.updateItem(item, {
        labelCfg: {
          style: {
            opacity: val,
          },
        },
      });
    },
    // Node Double Click
    nodeDblClick(e) {
      if (this.$store.state.edit_mode === 'node_operation') {
        const nodeItem = e.item;
        const nodeModel = nodeItem.getModel();
        const nodeId = nodeModel.id;
        console.log('nodeDblClick', nodeModel);
        this.updateNode.nodeLabel = nodeModel.label;
        this.updateNode.position = {
          x: e.clientX,
          y: e.clientY,
        };
        this.updateNode.id = nodeId;
        this.nodeUpdating = true;
      }
    },

    // G6 Explore mouse move
    exploreMouseMove(e) {
      if (this.$store.state.edit_mode === 'add_relationships') {
        const point = {
          x: e.x,
          y: e.y,
        };
        if (this.addingEdge && this.edge) {
          graphReactor.exploreInstance.updateItem(this.edge, {
            target: point,
            label: this.$store.state.newEdgeLabel,
          });
        }
      }
    },

    // click on the edge
    edgeClick(e) {
      if (this.$store.state.edit_mode === 'add_relationships') {
        const currentEdge = e.item;
        // 拖拽过程中，点击会点击到新增的边上
        if (this.addingEdge && this.edge === currentEdge) {
          graphReactor.exploreInstance.removeItem(this.edge);
          this.edge = null;
          this.addingEdge = false;
        }
      } else if (this.$store.state.edit_mode === 'remove') {
        const currentEdge = e.item;
        // 拖拽过程中，点击会点击到新增的边上
        graphReactor.exploreInstance.removeItem(currentEdge);
        graphReactor.exploreInstance.updateLayout();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/abstracts/_variables.scss";

div {
  font-family: "Helvetica", sans-serif;
}
#mainGraphPane {
  background: #576f7f;
  width: 100%;
  height: 100%;
  position: absolute;
}
#viewnode {
  padding: 0.9375em 0.9375em;
}

.propsShowcase {
  position: absolute;
  bottom: 0;
  right: 40px;
  font-family: 'Poppins', sans-serif;
  color: #fff;

  .propName {
    color: #fdc400;
  }
}

</style>
